<div class="text-config">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <div class="mt-2 d-flex align-items-center justify-content-between gap-2">
        <p class="mb-0">Kích thước:</p>
        <mat-form-field title="Size" style="width: 50%">
          <mat-label> {{'kich_thuoc' | translate}}</mat-label>
          <input (blur)="updateClass()" matInput type="number" [ngModel]="class['text__editor']['font-size'] | vhnumber"
            (ngModelChange)="class['text__editor']['font-size'] =$event + 'px'" />
        </mat-form-field>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="configMode == 'advanced'">
      
    <app-width-height-config 
    [elementChoosing]="objectChoosing"
    [device]="device" 
    [width]="class['text']['width']"  
    [height]="class['text']['height']"
    (changeWidthHeight)="changeWidthHeight($event)">
  </app-width-height-config>

  <!-- Lựa chọn hiển thị cho các thiết bị -->
  <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
  </app-hide-show-config>
  <div class="mt-2 d-flex align-items-center justify-content-between gap-2">
    <p class="mb-0">{{'kich_thuoc' | translate}}:</p>
    <mat-form-field title="Size" style="width: 50%">
      <mat-label> {{'kich_thuoc' | translate}}</mat-label>
      <input (blur)="updateClass()" matInput type="number" [ngModel]="class['text__editor']['font-size'] | vhnumber"
        (ngModelChange)="class['text__editor']['font-size'] =$event + 'px'" />
    </mat-form-field>
  </div>

  <!-- Khoảng cách dòng -->
  <ng-container>
    <div class="d-flex align-items-center justify-content-between gap-2">
      <p class="mb-0" style="width: 50%;">{{'khoang_cach_dong' | translate}}</p>
      <nz-input-number [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1" [(ngModel)]="class['text__editor']['line-height']"
        (nzBlur)="updateClass()">
      </nz-input-number>
    </div>
    <nz-row>
      <nz-col nzSpan="24">
        <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1" [(ngModel)]="class['text__editor']['line-height']"
          (nzOnAfterChange)="updateClass()">
        </nz-slider>
      </nz-col>
    </nz-row>
  </ng-container>

  <div class="view-type">
    <p class="view-type__title">{{'kieu_hien_thi' | translate}}:</p>
    <nz-select [(ngModel)]="class['text']['overflow-y']" (ngModelChange)="updateTypeDisplay()">
      <nz-option nzValue="visible" nzLabel="Dãn"></nz-option>
      <nz-option nzValue="auto" nzLabel="cuộn"></nz-option>
      <nz-option nzValue="hidden" nzLabel="cố định"></nz-option>
    </nz-select>
  </div>

  <div>
    <label>{{'chon_thong_so' | translate}}</label>
    <nz-select (ngModelChange)="updateStaticData()" nzAllowClear [nzPlaceHolder]="'chon_thong_so' | translate" [(ngModel)]="staticdata.field_custom" (ngModelChange)="updateStaticData()">
      <nz-option *ngFor="let item of newFieldCKEditors" [nzLabel]="item?.field_lable ?? item.field_custom" [nzValue]="item.field_custom"></nz-option>  
    </nz-select>
  </div>
  </ng-container>
</div>